// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"667":"32b7d55a","3901":"dd607d0c"}[chunkId] + ".chunk.css";
};